import React from 'react';
import KkpColorBadge from '../../kkp/KkpColorBadge';
import { getCommercialColor } from '../../../utils/commercialBadgeUtils';

const DashboardV2VendeurLabel = ({ vendeur, rowType, colorByName }) => {
  if (rowType === 'total' || rowType === 'global') {
    return <div className="v2-row-vendeur">{vendeur}</div>;
  }

  return (
    <div className="v2-row-vendeur">
      <KkpColorBadge color={getCommercialColor(colorByName, vendeur)} vivid>
        {vendeur}
      </KkpColorBadge>
    </div>
  );
};

export default DashboardV2VendeurLabel;
